/** Copy Media Lab orientado a casa productora (cliente Mercosur), no a creador independiente. */
export const mercosurMediaLabWho = {
  title: 'TNO Media Lab: su casa productora de podcast',
  subtitle:
    'Infraestructura broadcast, talento senior y empaquetado listo para que Mercosur Casa de Bolsa distribuya en sus canales.',
  description:
    'TNO Media Lab es el centro de producción avanzada de TNO Network: estudios, ingeniería de audio e imagen, postproducción y estándares broadcast. Para Mercosur actuamos como casa productora externa: asumimos preproducción, grabación, edición, clips, manejo del canal de YouTube, campañas de promoción y entrega de la “lata” por episodio. Ustedes definen el mensaje; nosotros producimos, publicamos y promovemos.',
};

export const mercosurMediaLabWhy = {
  title: '¿Por qué producir con TNO Media Lab?',
  description:
    'Somos el partner de producción diseñado para marcas que necesitan un podcast de autoridad sin montar un estudio propio. Integramos tecnología broadcast, Margarita Toledo y Yelitza Yánez, y un flujo mensual: cuatro episodios de 45 minutos, doce clips por episodio, manejo operativo del canal de YouTube y campañas de promoción para que cada entrega tenga visibilidad desde el primer día.',
  ctaText: 'Agendar reunión de producción',
};

export const mercosurMediaLabBenefits = {
  overline: 'Casa productora',
  title: 'Lo que el Media Lab pone sobre la mesa',
  subtitle:
    'El mismo núcleo tecnológico y humano del Lab, aplicado a un proyecto de marca: un solo interlocutor, entregables claros y calidad broadcast.',
  items: [
    {
      title: 'Infraestructura broadcast (Innovación)',
      subtitle:
        'Estudios, captura multicámara, audio profesional y flujos de postproducción. Su podcast compite al nivel de las producciones originales del ecosistema TNO.',
      colorKey: 'blue',
    },
    {
      title: 'Equipo productor dedicado (Humano)',
      subtitle:
        'Margarita Toledo y Yelitza Yánez lideran asesoría, montaje del proyecto, conducción y supervisión editorial. Lenguaje financiero claro y tono alineado a Mercosur.',
      colorKey: 'teal',
    },
    {
      title: 'Operación mensual estructurada (Proceso)',
      subtitle:
        'Cuatro programas al mes con preproducción, producción y postproducción. Calendario de grabación, entregas y checklist de publicación acordados desde el arranque.',
      colorKey: 'amber',
    },
    {
      title: 'YouTube y promoción (Distribución)',
      subtitle:
        'Manejo del canal de YouTube (episodios, Shorts, SEO y playlists), campañas de promoción multicanal y empaquetado “lata”. El Lab publica, impulsa y entrega; Mercosur capitaliza la audiencia.',
      colorKey: 'pink',
    },
  ],
};

export const mercosurMediaLabValues = {
  overline: 'Valores del Lab',
  title: 'ADN de producción',
  hideAdnHeading: true,
  subtitle:
    'Los mismos principios que guían al Media Lab, aplicados a un proyecto corporativo de educación financiera y mercado de valores.',
  items: [
    {
      title: 'Excelencia técnica',
      subtitle: 'Estándar broadcast en grabación, edición y master. Sin improvisación en equipos ni entregables.',
    },
    {
      title: 'Claridad editorial',
      subtitle: 'Contenido de valor para inversionistas y emprendedores, con rigor y cercanía.',
    },
    {
      title: 'Entrega llave en mano',
      subtitle: 'Un partner, un calendario, una “lata” por episodio. Mercosur se enfoca en distribución y negocio.',
    },
  ],
};

export const mercosurMediaLabAreYouReady = {
  headline: 'Produzcamos el podcast de Mercosur',
  subheadline: '¿Listos para el primer mes de cuatro episodios?',
  body:
    'Agendemos con Margarita y Yeyé el arranque: paquete gráfico, montaje del proyecto y calendario de grabación en TNO Media Lab.',
  ctaPrimary: 'Quiero esta propuesta de producción',
  ctaSecondary: 'Ver propuesta TNO Network',
  ctaSecondaryHref: '/mercosur',
  whatsappNumber: '04123964576',
  footerText:
    '© TNO Network 2026 | Mercosur Casa de Bolsa × TNO Media Lab · Propuesta 2 Producción | The Content Evolution.',
};
